import styled, { css } from "styled-components"

import Typography from "~/components/atoms/Typography"
import { Color, IsMobile, SpacingSize } from "~/consts/style-mixins"

interface Props {
  color: keyof typeof Color
  linkColor?: keyof typeof Color
}

const InternshipGuarantee = ({ color, linkColor }: Props) => {
  return (
    <Container type="SubNote" color={color} linkColor={linkColor}>
      * 保証条件を満たす必要があります。
      <a href="/next/internship-guarantee-policy" target="_blank" className="link">
        詳しくはこちら
      </a>
    </Container>
  )
}

const Container = styled(Typography)`
  color: ${Color.Gray};
  margin-top: ${SpacingSize["3XS"]}px;
  ${IsMobile(css`
    font-size: 10px;
    line-height: 160%;
  `)}
  ${({ color }: Props) => css`
    color: ${Color[color]};
  `}

  .link {
    display: inline;
    font-weight: normal;
    ${IsMobile(css`
      font-size: 10px;
    `)}
    color: ${Color.Secondary};
    ${({ linkColor }: Props) => css`
      ${linkColor !== undefined &&
      css`
        color: ${Color[linkColor]};
      `}
    `}
  }
`

export default InternshipGuarantee
